/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentRewardStatusRequest} from '@cash-web/protos/squareup/franklin/app/reward_status.pb'
import {GetPaymentRewardStatusResponse} from '@cash-web/protos/squareup/franklin/app/reward_status.pb'


export const getPaymentRewardStatus = (request:GetPaymentRewardStatusRequest, options?: CashRequestOptions) => post<GetPaymentRewardStatusRequest, GetPaymentRewardStatusResponse>("/2.0/cash/get-payment-reward-status", request, {...options, rejectOnError: true })